module.exports = __webpack_public_path__ + "OpenSans-Semibold.33f225b8f5f7d6b34a09.ttf";


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/assets/ra/fonts/OpenSans-Semibold.ttf
// module id = ../../../../../assets/ra/fonts/OpenSans-Semibold.ttf
// module chunks = main